import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ReferenceDataContextualHelps } from '../../../../lib/constants/reference-data-contextual-helps';
import { ReferenceDataLabels } from '../../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../../lib/constants/reference-data-option-lists';
import { CaseProduct } from '../../../mortgage-application/models/case-product.model';
import { PartAndPartProductService } from '../../../shared/services/part-and-part-product.service';
import { Kfi } from '../../models/kfi.model';

@Component({
  selector: 'boi-kfi-about-the-mortgage-control',
  templateUrl: './kfi-about-the-mortgage-control.component.html',
  styleUrls: ['./kfi-about-the-mortgage-control.component.scss']
})
export class KfiAboutTheMortgageControlComponent implements OnChanges {
  @Input() public kfi: Kfi;
  @Input() public isReadOnly: boolean;
  @Output() public readonly isFeeUpToDateChange = new EventEmitter<boolean>();

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public ReferenceDataContextualHelps = ReferenceDataContextualHelps;

  constructor(private readonly cdr: ChangeDetectorRef, public partAndPartProductService: PartAndPartProductService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.kfi && changes.kfi.currentValue) {
      this.partAndPartProductService.application = this.kfi;
      this.partAndPartProductService.firstProduct = this.kfi.CaseProducts[0];
      this.partAndPartProductService.setRepaymentTypeFlags();
      if (this.partAndPartProductService.isProductPartRepaymentPartInterest) {
        this.partAndPartProductService.secondProduct = this.kfi.CaseProducts[1];
      }
    }
  }

  public setLoanAmount(newAmount: number): void {
    this.partAndPartProductService.setLoanAmount(newAmount);
    this.cdr.detectChanges();
  }

  public setRepaymentType(newRepaymentType: string): void {
    this.partAndPartProductService.setRepaymentType(
      newRepaymentType,
      this.addRepaymentPartProduct,
      this.deleteRepaymentPartProduct,
      this.kfi.CaseProducts
    );
    this.cdr.detectChanges();
  }

  public addRepaymentPartProduct(caseProducts: Array<CaseProduct>, repaymentPartProduct: CaseProduct): void {
    caseProducts.push(repaymentPartProduct);
  }

  public deleteRepaymentPartProduct(caseProducts: Array<CaseProduct>): void {
    caseProducts.pop();
  }

  public setInterestOnlyPart(value: number): void {
    this.partAndPartProductService.setInterestOnlyPart(value);
    this.cdr.detectChanges();
  }
}
